// #genai Phase 2 remove-payment-method modal styles — pixel-matched to Figma 730:30547 (desktop)
// and 269:20479 (mobile). Desktop dialog is 450px wide; mobile is 342px. padding 24, radius 4,
// ev-elevation--z24 shadow; title #1B202C 18px semibold (explicit 2-line break before "Ending in"),
// message #61687D 14px; 26px gap between title and message; right-aligned Cancel / Yes,Remove on
// desktop (8px gap), full-width stacked on mobile (Yes,Remove on top, 16px gap).
import { makeStyles } from 'lib/components';

export default makeStyles(() => ({
  dialog: {
    // #genai Figma 730:30547 — desktop modal frame is 450px wide (was 342 which cramped the title to
    // 3 lines). Mobile (Figma 269:20479 'Cancel Order Dialog') keeps the 342px frame.
    width: '450px',
    maxWidth: 'calc(100% - 32px)',
    margin: 0,
    padding: '24px',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 11px 15px 0px rgba(0,0,0,0.2), 0px 9px 46px 0px rgba(0,0,0,0.12), 0px 24px 38px 0px rgba(0,0,0,0.14)',
    '@media (max-width: 639px)': {
      width: '342px',
      maxWidth: 'calc(100% - 48px)',
    },
  },

  title: {
    padding: 0,
    fontFamily: 'Noto Sans',
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '27px',
    color: '#1B202C',
    // #genai Figma 730:30547 title is a two-line node — "Remove {label}" on line 1 and
    // "Ending in {lastFour}?" on line 2 (explicit \n in the i18n string). pre-line honours that break
    // at every width so the modal height matches the design even when the label is short enough to fit
    // on one line at 450px.
    whiteSpace: 'pre-line',
  },

  content: {
    padding: 0,
    marginTop: '26px',
  },

  message: {
    margin: 0,
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: '#61687D',
  },

  actions: {
    padding: 0,
    marginTop: '24px',
    gap: '8px',
    justifyContent: 'flex-end',
    // #genai Mobile (Figma 269:20502): stack full-width with "Yes, Remove" on top, "Cancel" below.
    '@media (max-width: 639px)': {
      flexDirection: 'column-reverse',
      alignItems: 'stretch',
      gap: '16px',
    },
  },

  cancelButton: {
    height: '44px',
    padding: '10px 16px',
    borderRadius: '4px',
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '0.32px',
    textTransform: 'none',
    backgroundColor: '#FFFFFF',
    color: '#007CAD',
    border: '1px solid #007CAD',
    '&:hover': {
      backgroundColor: 'rgba(0,124,173,0.06)',
    },
    '@media (max-width: 639px)': {
      width: '100%',
      marginLeft: 0,
    },
  },

  confirmButton: {
    height: '44px',
    padding: '10px 16px',
    borderRadius: '4px',
    fontFamily: 'Noto Sans',
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '0.32px',
    textTransform: 'none',
    backgroundColor: '#007CAD',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#005A8D',
    },
    '@media (max-width: 639px)': {
      width: '100%',
      marginLeft: 0,
    },
  },
}));
